/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { NgModule } from '@angular/core';
import { provideDefaultConfig } from '@lm-nx-frontend/lm-inf-core';
import { OccAccountSummaryAdapter } from './adapters/occ-account-summary.adapter';
import { defaultOccAccountSummaryConfig } from './config/default-occ-account-summary-config';
import {AccountSummaryAdapter} from "../core/connectors";

@NgModule({
  providers: [
    provideDefaultConfig(defaultOccAccountSummaryConfig),
    { provide: AccountSummaryAdapter, useClass: OccAccountSummaryAdapter },
  ],
})
export class AccountSummaryOccModule {}
